import { render, staticRenderFns } from "./ArtistAlbumsList.vue?vue&type=template&id=95460b68&scoped=true&"
import script from "./ArtistAlbumsList.vue?vue&type=script&lang=js&"
export * from "./ArtistAlbumsList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistAlbumsList.vue?vue&type=style&index=0&id=95460b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95460b68",
  null
  
)

export default component.exports